/*
 * Tolerance (in metres) for pallet geometry comparisons — a box that fits the
 * pallet exactly must not be rejected by floating-point noise.
 */
export var palletEpsilon = 1e-4;
/*
 * A box's actual footprint extents after its Y rotation: 90/270 swap the X and
 * Z extents, 0/180 leave them as they are.
 */
export var getRotatedFootprint = function (objectSize, rotation) {
    return Math.abs(rotation % 180) === 0
        ? { x: objectSize.x, z: objectSize.z }
        : { x: objectSize.z, z: objectSize.x };
};
/*
 * The world-space footprint of an unrotated cardboard box. The 3D box swaps
 * `objectSize`'s axes — its world X-extent is `objectSize.z` and its world
 * Z-extent is `objectSize.x` (see the `dimensions` mapping in
 * `cardboard-builder`) — so anything reasoning about box positions in world
 * space has to swap them too, or non-square boxes end up spaced by the wrong
 * axis.
 */
export var getBoxWorldFootprint = function (objectSize) { return ({ x: objectSize.z, z: objectSize.x }); };
/*
 * One box's world-space footprint, unrotated: its own size when it has one,
 * the size every box shares (`objectSize`) otherwise.
 */
export var getCardboardBoxWorldFootprint = function (box, objectSize) { var _a; return getBoxWorldFootprint((_a = box.size) !== null && _a !== void 0 ? _a : objectSize); };
/*
 * Whether a box's centre sits on the pallet. The pallet is an axis-aligned
 * rectangle of `length` (X) × `width` (Z) centred at `palletCentre`. A box is
 * "on" the pallet when its centre is within that rectangle (overhang is
 * allowed — only the centre leaving the area counts as outside). The boundary
 * is inclusive.
 */
export var isBoxCentreOnPallet = function (boxCentre, pallet, palletCentre) {
    var dx = Math.abs(boxCentre.x - palletCentre.x);
    var dz = Math.abs(boxCentre.z - palletCentre.z);
    return dx <= pallet.length / 2 && dz <= pallet.width / 2;
};
/*
 * Whether a box's whole footprint sits within the pallet — the stricter
 * counterpart to `isBoxCentreOnPallet`. Used when generating palletizing
 * patterns: a generated box must never hang off the pallet, while a box the
 * user has dragged there by hand may (see `isBoxCentreOnPallet`).
 *
 * A footprint larger than the pallet can never be inside, whatever its centre.
 */
export var isBoxFootprintOnPallet = function (boxCentre, footprint, pallet, palletCentre) {
    var dx = Math.abs(boxCentre.x - palletCentre.x);
    var dz = Math.abs(boxCentre.z - palletCentre.z);
    return (dx <= (pallet.length - footprint.x) / 2 + palletEpsilon &&
        dz <= (pallet.width - footprint.z) / 2 + palletEpsilon);
};
